class StaticControls {
    constructor(camera) {
        this._camera = camera;
    }

    update() { }
    get isStaticControls() { return true; }
    isDamping() { return false; }
    setPanLimits(center, quaternion, offset) { }

    cancelDamping() { }

    setAzimuthalAngle(theta) { }

    setPolarAngle(phi) { }

    setAutoSpin(object, enabled, speed) { }

    get target() { return Q3.physicalCameraControls.target; }
    get object() { return this._camera; }
}

export default StaticControls;
export { StaticControls };